module.exports = __webpack_public_path__ + "static/media/sensors-home-2.a8b3705c.svg";